var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    class: _vm.labelClasses,
    attrs: {
      "for": _vm.realId
    }
  }, [_c('span', {
    staticClass: "Polaris-Choice__Control"
  }, [_c('div', {
    class: _vm.checkboxClasses
  }, [_c('input', {
    class: _vm.inputClasses,
    attrs: {
      "type": "checkbox",
      "id": _vm.realId,
      "name": _vm.name,
      "aria-invald": _vm.error == true,
      "aria-describedBy": _vm.helpTextId + ' ' + _vm.errorId,
      "role": "checkbox",
      "aria-checked": _vm.indeterminate ? 'mixed' : (_vm.checked ? 'true' : null),
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.checked
    },
    on: {
      "change": _vm.onChange,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Checkbox__Backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Checkbox__Icon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.checkIcon
    }
  })], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "Polaris-Choice__Label"
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "    \n        ")])]), _vm._v(" "), (_vm.helpText || _vm.$slots.helpText || (_vm.error && (typeof _vm.error == 'string'))) ? _c('div', {
    staticClass: "Polaris-Choice__Descriptions"
  }, [(_vm.error && (typeof _vm.error == 'string')) ? _c('div', {
    staticClass: "Polaris-Choice__Error",
    attrs: {
      "id": "errorId"
    }
  }, [_c('div', {
    staticClass: "Polaris-Choice__ErrorIcon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.checkboxErrorIcon
    }
  })], 1), _vm._v("\n            " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.helpText || _vm.$slots.helpText) ? _c('div', {
    staticClass: "Polaris-Choice__HelpText",
    attrs: {
      "id": _vm.helpTextId
    }
  }, [_vm._t("helpText", [_vm._v(_vm._s(_vm.helpText))])], 2) : _vm._e()]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-457adbbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457adbbc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisCheckbox.vue
// module id = 243
// module chunks = 0